import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export function formatCNPJ(cnpj: string): string {
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function formatDate(
  date: Date | string,
  formatStr = "dd/MM/yyyy"
): string {
  if (!date) {
    return "";
  }
  try {
    if (typeof date === "string") {
      return format(parseISO(date), formatStr, {
        locale: ptBR,
      });
    }
    return format(date, formatStr, {
      locale: ptBR,
    });
  } catch (error) {
    console.log("error on format date", date);
    return "";
  }
}

export function formatNumber(val: number, decimalPlaces = 0, showZero = false) {
  if (!val) {
    const zeroVal = 0;
    return showZero ? zeroVal.toFixed(decimalPlaces).replace(".", ",") : "";
  }
  if (typeof val === "number") {
    return val
      .toFixed(decimalPlaces)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  } else {
    return parseFloat(val)
      .toFixed(decimalPlaces)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
}
